import { useEffect } from 'react';

/**
 * Calls `handler` when a mousedown occurs outside all of the given refs.
 * Pass a single ref or an array of refs to treat as "inside".
 * The listener is only attached while `active` is true.
 */
export function useClickOutside(refs, handler, active = true) {
  useEffect(() => {
    if (!active) return;
    const list = Array.isArray(refs) ? refs : [refs];
    const onMouseDown = (e) => {
      if (list.every((r) => r.current && !r.current.contains(e.target))) handler(e);
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [active]);
}
